import { useEffect, useState } from 'react';
import {
  EMERGENCY_EVENT,
  refreshEmergencyStatus,
} from '@/lib/emergencyHours';
import { getOpeningSnapshot, HOURS, type OpeningSnapshot } from '@/lib/hours';
import styles from './OpeningHours.module.css';

export function OpeningHours() {
  const [snap, setSnap] = useState<OpeningSnapshot>(() => getOpeningSnapshot());

  useEffect(() => {
    const tick = () => setSnap(getOpeningSnapshot());
    tick();
    void refreshEmergencyStatus().then(tick);

    const id = window.setInterval(() => {
      void refreshEmergencyStatus().then(tick);
    }, 60_000);

    const onChange = () => tick();
    window.addEventListener(EMERGENCY_EVENT, onChange);
    window.addEventListener('storage', onChange);

    return () => {
      window.clearInterval(id);
      window.removeEventListener(EMERGENCY_EVENT, onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);

  return (
    <div
      className={styles.wrap}
      role="group"
      aria-label={snap.summary}
    >
      <div className={styles.statusRow}>
        <span className={styles.today}>{snap.todayLine}</span>
        <span
          className={[
            styles.badge,
            snap.isOpenNow ? styles.badgeOpen : styles.badgeClosed,
          ].join(' ')}
        >
          <span className={styles.dot} aria-hidden="true" />
          {snap.statusLabel}
        </span>
      </div>

      <ol className={styles.week} aria-hidden="true">
        {snap.days.map((day) => (
          <li
            key={day.label}
            className={[
              styles.day,
              day.isOpenDay ? styles.dayOpen : styles.dayClosed,
              day.isToday ? styles.dayToday : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <span className={styles.dayLabel}>{day.label}</span>
            <span className={styles.dayBar} />
            <span className={styles.dayTime}>
              {day.isOpenDay ? '9–17' : '—'}
            </span>
          </li>
        ))}
      </ol>

      <p className={styles.footnote}>
        E–R {HOURS.displayRange}
        <span className={styles.footnoteSep}>·</span>
        broneeri helistades
      </p>
    </div>
  );
}
